import React from 'react'
import ReactDOM from 'react-dom/client'
import { stripLocalePrefix } from '@redevicer/shared'
import App from './App'
import AppErrorBoundary from './components/AppErrorBoundary'
import ImeiCheckoutPage from './components/ImeiCheckoutPage'
import './index.css'
import './styles/verify-report-premium.css'
import './styles/verify-report-export.css'
import './styles/verify-loading.css'
import './helpo24-theme.css'
import './i18n'

const checkoutPath = stripLocalePrefix(window.location.pathname)
const isImeiCheckout = checkoutPath === '/imei-checkout' || checkoutPath.startsWith('/imei-checkout/')

ReactDOM.createRoot(document.getElementById('root')!).render(
  isImeiCheckout ? (
    <ImeiCheckoutPage />
  ) : (
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>
  ),
)
